// extracted by mini-css-extract-plugin
export default {"wrapper":"not-found-page_wrapper__sFaUr","buttons":"not-found-page_buttons__d6YUH"};